<template>
  <v-dialog
    v-model="showModal"
    max-width="400"
  >
    <v-card>
      <v-card-title style="background-color: #37474F; color: #ffffff">
        {{ title }}
        <v-spacer />

        <v-icon
          aria-label="Close"
          color="white"
          @click="showModal = false"
        >
          mdi-close
        </v-icon>
      </v-card-title>
      <v-card-text>
        <p class="message-style">
          {{ message }}
        </p>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="showModal = false"
          >
            {{ button1 }}
          </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="$emit('confirmed')"
          >
            {{ button2 }}
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    name: 'DeleteDialog',
    props: {
      title: {
        type: String,
        default: 'Delete',
      },
      message: {
        type: String,
        default: 'This action will permanently remove the item.',
      },
      button1: {
        type: String,
        default: 'Cancel.',
      },
      button2: {
        type: String,
        default: 'Delete',
      },
    },
    data: () => ({
      showModal: true,
    }),
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
  };
</script>
<style scoped>
.v-dialog .v-card .v-card__title {
  padding: 18px 18px;
  text-align: left;
  font-size: 1.25rem;
}
.message-style {
  font-weight: 500;
  color: #455A64;
}
</style>
